
import {defineComponent, PropType} from "vue";

export default defineComponent({
  name: "ContentControlButton",
  props: {
    title: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean
    },
    type: {
      type: String as PropType<"previous" | "next" | "finish">,
      required: true
    }
  }
});
